import { createSlice } from "@reduxjs/toolkit";
import { coreApi } from "api/core";

const initialState = {
  nextOrderNumber: "",
  supplierIdentifier: "",
  loading: false,
  error: null,
};

const orderNumbersSlice = createSlice({
  name: "orderNumbers",
  initialState,
  reducers: {
    setNextOrderNumber: (state, action) => {
      state.nextOrderNumber = action.payload.nextOrderNumber;
      state.supplierIdentifier = action.payload.supplierIdentifier;
      state.loading = false;
      state.error = null;
    },
    setOrderNumbersLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setOrderNumbersError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearOrderNumbers: (state) => {
      state.nextOrderNumber = "";
      state.supplierIdentifier = "";
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setNextOrderNumber, setOrderNumbersLoading, setOrderNumbersError, clearOrderNumbers } =
  orderNumbersSlice.actions;

// Selectors
export const selectNextOrderNumber = (state) => state.orderNumbers.nextOrderNumber;
export const selectSupplierIdentifier = (state) => state.orderNumbers.supplierIdentifier;
export const selectOrderNumbersLoading = (state) => state.orderNumbers.loading;
export const selectOrderNumbersError = (state) => state.orderNumbers.error;

// Thunks
export const fetchNextOrderNumber = () => async (dispatch) => {
  dispatch(setOrderNumbersLoading());

  try {
    const response = await coreApi.fetch("/order-numbers/next");
    dispatch(setNextOrderNumber(response));
    return response;
  } catch (error) {
    dispatch(setOrderNumbersError(error.message));
    throw error;
  }
};

export const generateDeliveryNoteNumber = (orderNumber) => async (dispatch) => {
  try {
    const response = await coreApi.post("/order-numbers/generate-delivery-note", {
      order_number: orderNumber,
    });
    return response;
  } catch (error) {
    console.error("Failed to generate delivery note number:", error);
    throw error;
  }
};

export default orderNumbersSlice.reducer;
